import { render } from "./_img-wrapper.vue?vue&type=template&id=4d593f6a"
import script from "./_img-wrapper.vue?vue&type=script&lang=js"
export * from "./_img-wrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__